module.exports = __webpack_public_path__ + "img/2010 winteressen 017.32253562.jpg";